import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Field, Control, Label } from "rbx";
import { useLazyQuery } from "@apollo/react-hooks";

import { ALL_ORDERS_QUERY } from "../../graphql/Orders/Orders.graphql";
import { LocationSelect, DateInput } from "../inputs";
import TripSelect from "../TripSelect";

function TripKeySelect({ disabled, onChange }) {
  const [inputs, setInputs] = React.useState({});
  const [getOrders, { data: OrdersData }] = useLazyQuery(ALL_ORDERS_QUERY);
  const [locations, setLocations] = React.useState([]);

  const handleChange = (name, value) => {
    if (name === "pickupDate") {
      setLocations([]);
      setInputs(prev => ({
        ...prev,
        pickupDate: value,
        pickupLocation: "",
        Trip: ""
      }));
    } else if (name === "pickupLocation") {
      setInputs(prev => ({ ...prev, pickupLocation: value, Trip: "" }));
    } else {
      setInputs(prev => ({ ...prev, [name]: value }));
    }
  };
  useEffect(() => {
    if (typeof onChange === "function") {
      if (inputs.pickupDate && inputs.pickupLocation && inputs.Trip) {
        onChange(
          `${inputs.pickupDate}_${inputs.pickupLocation}_${inputs.Trip}`
        );
      } else {
        onChange("");
      }
    }
  }, [inputs.Trip, inputs.pickupDate, inputs.pickupLocation, onChange]);

  useEffect(() => {
    if (inputs.pickupDate) {
      getOrders({
        variables: {
          where: {
            TripKey_startsWith: inputs.pickupDate
          }
        },
        fetchPolicy: "cache-and-network"
      });
    }
  }, [inputs.pickupDate, getOrders]);

  useEffect(() => {
    const orders = OrdersData?.Orders;

    if (orders) {
      setLocations([
        ...new Set(
          orders.map(order => {
            const [, pickupLocation] = order.TripKey.split("_");
            return parseInt(pickupLocation, 10);
          })
        )
      ]);
    }
  }, [OrdersData]);

  return (
    <React.Fragment>
      <Field
        className="grid-override is-three"
        kind="group"
        style={{ gridColumn: "span 3" }}
      >
        <Control expanded>
          <Label>Trip Pickup Date</Label>
          <DateInput
            disabled={disabled}
            name="pickupDate"
            value={inputs.pickupDate}
            onChange={({ target: { name, value } }) => {
              handleChange(name, value);
            }}
          />
        </Control>
        <Control expanded>
          <LocationSelect
            disabled={disabled}
            label="Trip Pickup Location"
            name="pickupLocation"
            showHelp={false}
            value={inputs.pickupLocation}
            where={
              locations.length
                ? {
                    RecId_in: locations
                  }
                : {}
            }
            onChange={({ target: { name, value } }) => {
              handleChange(name, value);
            }}
          />
        </Control>
        <Control expanded>
          <TripSelect
            disabled={disabled}
            label="Trip"
            name="Trip"
            pickupDate={inputs.pickupDate}
            pickupLocation={inputs.pickupLocation}
            value={inputs.Trip}
            onChange={handleChange}
          />
        </Control>
      </Field>
    </React.Fragment>
  );
}

TripKeySelect.propTypes = {
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};

export default TripKeySelect;
